import { Profile, StringMap, GetProfilesOutput, RequestContext } from 'DVWebNodeUtils'

export interface ProfilesProps {
    isCerberusEnabled: boolean,
    data: GetProfilesOutput
  }
  
export interface NavProfiles {
    strings: StringMap,
    links: StringMap,
    activeProfile: Profile,
    otherProfiles: Profile[],
    tooltipType: 'WELCOME' | 'INTRO' | null
}

export const transformProfiles = (cerberusProps: ProfilesProps, context: RequestContext) => {
    const cerberusData = cerberusProps.isCerberusEnabled && cerberusProps.data

    const hasIntroTooltip = cerberusData && cerberusData.showIntro
    const hasWelcomeTooltip = context.parameters['switchSuccess'] && context.parameters['switchSuccess'].value === '1'
    const tooltipType = hasIntroTooltip ? 'INTRO' as 'INTRO' : hasWelcomeTooltip ? 'WELCOME' as 'WELCOME' : null
    
    if (cerberusData) {
        return {
            strings: cerberusData.strings,
            links: cerberusData.links,
            activeProfile: cerberusData.profiles.find(_ => _.isSelected),
            otherProfiles: cerberusData.profiles.filter(_ => !_.isSelected),
            tooltipType: tooltipType
        }
    }
    return null
}
